<template>
  <div>
    <div v-if="projects.length === 0" class="text-center p-4">
      <p class="text-muted">Пусто</p>
    </div>

    <div v-else>
      <table class="table">
        <thead>
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Название</th>
          <th scope="col">Действие</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, index) in projects" :key="index">
          <th scope="row">{{ row.id }}</th>
          <td>{{ row.name }}</td>
          <td>
            <router-link :to="{name: 'email_mailing_detail', params: { id: row.id }}" class="btn btn-link p-0 me-2">
              Перейти
            </router-link>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useProjectStore } from '@/store/projects'

const projectStore = useProjectStore()

// project list
const projects = computed(() => projectStore.items)

onMounted(() => {
  projectStore.getList()
});
</script>